import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.constants';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungConstantsEffects {

    Constants$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CONSTANTS),
        mergeMap((x: ac.GetConstantsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getConstants().pipe(
                map((result: any) => {
                    return new ac.GetConstantsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetConstantsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungTemplatesService);
        }
        return this.service;
    }
}
